import type { FC } from 'react';
import { ClientOnly } from '../client-only/ClientOnly';
import { Recommendations } from './Recommendations';
import { RecommendationsSkeleton } from './RecommendationsSkeleton';
import type { BloomreachWidget } from '../../bff-api/bloomreach-recommendation/model/BloomreachWidget';
import type { BloomreachProductType } from '../../bff-api/bloomreach-recommendation/model/bloomreach';
import type { RecommendationPlaces } from '../../hooks/useRecommendations';

type ClientRecommendationsProps = {
    widget: BloomreachWidget;
    productTypeFilter?: BloomreachProductType;
} & RecommendationPlaces;

const ClientRecommendations: FC<ClientRecommendationsProps> = ({
    widget,
    categoryId,
    productId,
    brandCategoryId,
    collectionId,
    location,
    userId,
    productTypeFilter,
}) => (
    <ClientOnly key={widget.id} hideBelowTheFold skeleton={<RecommendationsSkeleton />}>
        <div className="w-full" data-testid={`recommendations-${widget.id}`}>
            <Recommendations
                title={widget.title}
                widgetType={widget.type}
                widgetId={widget.id}
                maxResults={widget.maxResults}
                categoryId={categoryId}
                productId={productId}
                brandCategoryId={brandCategoryId}
                collectionId={collectionId}
                location={location}
                userId={userId}
                productTypeFilter={productTypeFilter}
            />
        </div>
    </ClientOnly>
);

export default ClientRecommendations;
